import { z } from 'zod';
import { ownerActionSchema } from './owner';
export const SUPPORT_SESSION_MIN_MINUTES = 5;
export const SUPPORT_SESSION_MAX_MINUTES = 60;
export const SUPPORT_SESSION_DEFAULT_MINUTES = 30;
export const SUPPORT_HANDOFF_TTL_SECONDS = 60;
export const SUPPORT_ACCESS_NOTICE_HOURS = 72;
export const SUPPORT_ACCESS_LOG_LIMIT = 50;
export const ownerSignInAsSchema = ownerActionSchema.extend({
    userId: z.string().uuid().optional(),
    minutes: z.number().int().min(SUPPORT_SESSION_MIN_MINUTES).max(SUPPORT_SESSION_MAX_MINUTES).default(SUPPORT_SESSION_DEFAULT_MINUTES),
});
export const impersonationExchangeSchema = z.object({
    code: z.string().trim().min(32).max(128),
});
export const LIVE_SESSION_MAX_MINUTES = 60;
export const LIVE_SESSION_DEFAULT_MINUTES = 30;
export const LIVE_SESSION_AUDIT_ACTION = 'owner.tenant.user.live_session';
export const LIVE_SESSION_ENDED_AUDIT_ACTION = 'owner.tenant.user.live_session.ended';
export const ownerLiveSessionSchema = ownerActionSchema.extend({
    userId: z.string().uuid(),
    minutes: z.number().int().min(SUPPORT_SESSION_MIN_MINUTES).max(LIVE_SESSION_MAX_MINUTES).default(LIVE_SESSION_DEFAULT_MINUTES),
});
export const WATCH_SESSION_MINUTES = 30;
export const WATCH_BATCH_INTERVAL_MS = 500;
export const WATCH_BATCH_MAX_BYTES = 8 * 1024 * 1024;
export const WATCH_ROOM_LINGER_MS = 60_000;
export const OWNER_WATCH_NAMESPACE = '/owner-watch';
export const WATCH_AUDIT_ACTION = 'owner.tenant.user.watch';
export const WATCH_ENDED_AUDIT_ACTION = 'owner.tenant.user.watch.ended';
export const WATCH_ALLOWED_AUDIT_ACTION = 'owner.tenant.user.watch_allowed';
export const ownerWatchAllowedSchema = ownerActionSchema.extend({ allowed: z.boolean() });
//# sourceMappingURL=support-access.js.map